import { useModalDialog } from '@procurify/ui'
import { noop } from 'lodash'
import { useHistory, useParams } from 'react-router'

import { toast } from '@webapp/components/Notification'
import {
  useAppRoutes,
  useLocationHelper,
  useProcurifyIntl,
} from '@webapp/hooks'
import { type LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'
import {
  type LegalEntityListPageParams,
  LegalEntityListPageTabTypes,
} from '@webapp/platform/legal-entities/pages/types'
import messages from './messages'

interface FeatureSetTab {
  label: string
  to: string
}

export const useLegalEntityListFeatureSet = () => {
  const intl = useProcurifyIntl()
  const history = useHistory()
  const { tab } = useParams<LegalEntityListPageParams>()
  const { url } = useAppRoutes()
  const { getQueryString } = useLocationHelper()

  const [openCreateModal, closeCreateModal, createModalStates] =
    useModalDialog()

  const isActive = tab === LegalEntityListPageTabTypes.ACTIVE

  const tabs: FeatureSetTab[] = [
    {
      label: intl.formatMessage(messages.activeTabLabel),
      to: `${url('LegalEntityListPage', {
        tab: LegalEntityListPageTabTypes.ACTIVE,
      })}${getQueryString({ page: 1 })}`,
    },
    {
      label: intl.formatMessage(messages.inactiveTabLabel),
      to: `${url('LegalEntityListPage', {
        tab: LegalEntityListPageTabTypes.INACTIVE,
      })}${getQueryString({ page: 1 })}`,
    },
  ]

  const handleCreateSuccess = () => {
    toast.success({
      title: intl.formatMessage(messages.createSuccessToastTitle),
    })
    closeCreateModal()
  }

  const handleSelectEntity = (entity: LegalEntity) => {
    history.push(url('LegalEntityDetailsPage', { uuid: entity.uuid }))
  }

  return {
    state: {
      isActive,
      tabs,
      createModalStates,
    },
    methods: {
      onAdd: openCreateModal,
      closeCreateModal,
      handleCreateSuccess,
      onSelect: handleSelectEntity,
      // TODO(PLAT-4860): enable/disable flow.
      onDeactivate: noop,
      onActivate: noop,
    },
  }
}
